import { Link } from "react-router-dom";
import {
  FaChartLine, FaCalendarAlt, FaTasks, FaClipboardCheck,
  FaVoteYea, FaAward, FaFileAlt, FaFolder, FaClipboardList, 
  FaBullhorn, FaComments, FaPoll, FaUsers, FaUniversity, FaStickyNote
} from "react-icons/fa";

export default function HomePage() {
  const cards = [
    {
      title: "Dashboard",
      icon: <FaChartLine />,
      description: "Overview of council activity and metrics",
      link: "/dashboard",
      color: "#667eea",
    },
    {
      title: "Meetings",
      icon: <FaCalendarAlt />,
      description: "Schedule and manage council meetings",
      link: "/meetings",
      color: "#764ba2",
    },
    {
      title: "Tasks",
      icon: <FaTasks />,
      description: "Track and organize council tasks",
      link: "/tasks",
      color: "#48bb78",
    },
    {
      title: "Action Items",
      icon: <FaClipboardCheck />,
      description: "Track commitments from meetings",
      link: "/action-items",
      color: "#ed8936",
    },
    {
      title: "Attendance",
      icon: <FaClipboardCheck />,
      description: "Monitor meeting attendance and participation",
      link: "/attendance",
      color: "#9f7aea",
    },
    {
      title: "Internal Votes",
      icon: <FaVoteYea />,
      description: "Participate in anonymous council voting",
      link: "/votes",
      color: "#4299e1",
    },
    {
      title: "Nominations",
      icon: <FaAward />,
      description: "Nominate members for officer positions",
      link: "/nominations",
      color: "#38b2ac",
    },
    {
      title: "Elections",
      icon: <FaPoll />,
      description: "Manage election processes and campaigns",
      link: "/elections",
      color: "#ed64a6",
    },
    {
      title: "Documents",
      icon: <FaFileAlt />,
      description: "Access council documents and resources",
      link: "/documents",
      color: "#f56565",
    },
    {
      title: "Resource Library",
      icon: <FaFolder />,
      description: "Browse templates and shared resources",
      link: "/resources",
      color: "#805ad5",
    },
    {
      title: "Meeting Minutes",
      icon: <FaClipboardList />,
      description: "View past meeting minutes and notes",
      link: "/minutes",
      color: "#d69e2e",
    },
    {
      title: "Committee Notes",
      icon: <FaStickyNote />,
      description: "Running notes and updates from each committee",
      link: "/committee-notes",
      color: "#667eea",
    },
    {
      title: "Noticeboard",
      icon: <FaBullhorn />,
      description: "Read announcements and updates",
      link: "/noticeboard",
      color: "#48bb78",
    },
    {
      title: "Message Board",
      icon: <FaComments />,
      description: "Discuss topics with council members",
      link: "/messageboard",
      color: "#ed8936",
    },
    {
      title: "Members",
      icon: <FaUsers />,
      description: "View member profiles and directory",
      link: "/members",
      color: "#9f7aea",
    },
  ];

  return (
    <div
      style={{
        padding: "60px 40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Welcome Section */}
      <div style={{ textAlign: "center", marginBottom: "50px" }}>
        <img 
          src="/staff-council-logo.svg" 
          alt="Staff Council NYU Abu Dhabi" 
          style={{
            height: "100px",
            width: "auto",
            objectFit: "contain",
            marginBottom: "20px",
          }}
        />
      </div>

      {/* Cards Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginTop: "40px",
        }}
      >
        {cards.map((card) => (
          <Link
            key={card.title}
            to={card.link}
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "20px",
              textDecoration: "none",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.07)",
              transition: "all 0.3s ease",
              border: "1px solid #e2e8f0",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.07)";
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                background: `${card.color}20`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px",
              }}
            >
              <div style={{ fontSize: "20px", color: card.color }}>
                {card.icon}
              </div>
            </div>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              {card.title}
            </h2>
            <p
              style={{
                fontSize: "13px",
                color: "#718096",
                lineHeight: "1.5",
              }}
            >
              {card.description}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}
